// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2V-wY","row":"ProcedureTreatmentSummary_row__1aKxb"};